import { AsyncPipe, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LogLevel, LogSystem, LogSystemLevelUtils } from '@myapp/features/admin/models';
import { UtcToLocalPipe } from '@myapp/modules/fwcore/pipes/utc-to-local.pipe';
import { UiWindowService } from '@myapp/modules/fwcore/services';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { LabelModule } from '@progress/kendo-angular-label';

@Component({
  selector: 'app-log-system-detail',
  templateUrl: './log-system-detail.component.html',
  styleUrls: ['./log-system-detail.component.scss'],
  standalone: true,
  imports: [DialogModule, LabelModule, NgClass, ButtonModule, AsyncPipe, UtcToLocalPipe]
})

export class LogSystemDetailComponent {

  @Input() data!: LogSystem;
  @Output() cancel: EventEmitter<undefined> = new EventEmitter();

  constructor(public afUiWin: UiWindowService) { }

  protected getSeverityClass(level: LogLevel | string | undefined | null): string {
    return LogSystemLevelUtils.getClass(level);
  }
}
